<template>
    <v-menu offset-y v-model="isOpened" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">   
                <v-icon v-bind="attrs" small v-on="on">mdi-dots-vertical</v-icon>  
        </template>
        <v-list max-width="275">

            <v-list-item-title><span style="margin-left: 10px !important; font-weight: bold !important;">Department Favorites</span></v-list-item-title>
            <v-divider></v-divider>
            <v-list-item v-for="(item, index) in this.items" :key="index"
                         @click="doNothing()">
                <v-list-item-icon>
                    <v-icon v-if="isSelected(item)" color="orange" @click="setFavorite(item, false)" :key="componentKey">mdi-star</v-icon>
                    <v-icon v-else color="gray" @click="setFavorite(item, true)" style="opacity: 0.2" :key="componentKey">mdi-star</v-icon>
                </v-list-item-icon>
                <v-list-item-title @click="setFavorite(item, !isSelected(item))">{{item.listName}}</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="close()">
                <v-list-item-icon>
                    <v-icon color="green"> mdi-check</v-icon>
                </v-list-item-icon>

                <v-list-item-title>Close</v-list-item-title>
            </v-list-item>

        </v-list>
    </v-menu>
</template>

<script>
    import axios from "axios";

    export default {
        data: () => ({
            items: [],
            isOpened: false,
            model: [1],
            componentKey: 0
            
        }),
        props: {
            favoritesLists: {},
            materialItem: {},
            defaultFavoriteListId: {},
            caption: {}
        },
        watch: {
            isOpened: () => {}
        },
        created() {
            this.items = this.favoritesLists;
        },
        computed: {

        },
        methods: {
            doNothing() { return },
            close() { this.isOpened = false; },
            actionClick(item, action) {

            },
            isSelected(listItem) {

                var retval = false;

                this.materialItem.materialFavoriteLists.forEach((x) => {
                    if (listItem.id == x.favoriteList.id) {
                        retval = true;
                    }
                });

                return retval;

            },
            findMaterialFavoriteId(favoriteListId) {

                var retval = 0;

                this.materialItem.materialFavoriteLists.forEach((x) => {
                    if (favoriteListId == x.favoriteList.id) {
                        retval = x.favorite.id;
                    }
                });

                return retval;

            },
            async setFavorite(favoriteList, isFavorite) {

                var materialFavorite =  {
                    id: this.findMaterialFavoriteId(favoriteList.id),
                    originId: this.$route.params.locationId,
                    sendState: 0,
                    locationDepartmentId: this.$route.params.locationDepartmentId,
                    materialId: this.materialItem.id,
                    materialFavoriteListId: favoriteList.id,
                    defaultQuantity: 0,
                    isDeleted: !isFavorite
                };

                var materialFavoriteView =  {
                    favorite: materialFavorite,
                    favoriteList: favoriteList
                };

                var result = await axios.post(`/api/MaterialFavorite/materialfavoritelist`, materialFavoriteView);
                var data = result.data;

                if (!isFavorite) {

                    for (var i = 0; i < this.materialItem.materialFavoriteLists.length; i++) {
                        if (this.materialItem.materialFavoriteLists[i].favorite.id == data.favorite.id) {
                            this.materialItem.materialFavoriteLists.splice(i, 1);
                            break;
                        }
                    }
                    if (favoriteList.id == this.defaultFavoriteListId) {

                        this.materialItem.isDefaultFavorite = false;
                    }
                } else {

                    this.materialItem.materialFavoriteLists.push(data);
                    if (favoriteList.id == this.defaultFavoriteListId) {
                        this.materialItem.isDefaultFavorite = true;
                    }
                }
                //Changing this key will trigger a refresh on the components they are bound to
                this.componentKey += 1;
                this.materialItem.isFavorite = this.materialItem.materialFavoriteLists.length > 0;
                this.materialsLoading = false;

            },
        }
    }
</script>
<style>
    .v-list-item__title {
        font-size: 14px !important;
        padding-bottom:4px !important;
    }
    .v-list-item__icon {
        margin-right: 16px !important;
        margin-top: 8px !important;
        margin-bottom: 4px !important;
    }
    .v-list-item {
        max-height: 30px !important;
        align-items: center;
        display: flex;
        flex: 1 1 100%;
        letter-spacing: normal;
        outline: none;
        padding: 0 8px;
        position: relative;
        text-decoration: none;
    }
</style>